/* eslint-disable sort-keys */

export const breakpoints = [
  "320px",
  "384px",
  "768px",
  "1024px",
  "1280px",
  "1440px",
  "1920px",
]

// Keep in sync with --breakpoint-* variables in stylesheets/global.css
export const breakpointValues = [320, 384, 768, 1024, 1280, 1440, 1920]

export const breakpointNames = [
  "xsmall",
  "mobile",
  "tablet",
  "desktop",
  "large",
  "widescreen",
  "xlarge",
]
